<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex>
        <formAdminOnboardingAcctDatatable
          :account-id="accountId"
          :type="'update'"
          @update="openUpdateDialog" />
        <v-dialog
          v-model="updateAccount.showDialog"
          large
          persistent
          scrollable
          max-width="1000px">
          <v-card>
            <v-card-title>Update Workflow
              <a
                href="#"
                class="full-detail-link"
                @click="fullDetailForm = !fullDetailForm">
                <span v-if="!fullDetailForm">
                  <span v-if="isRecordView">Edit</span>
                  <span v-if="!isRecordView">View</span>
                  in full details</span>
                <span v-else> &lt; Back to simple</span>
              </a>
            </v-card-title>
            <v-card-text id="update-dialog-content">
              <v-container>
                <div
                  v-if="!fullDetailForm"
                  class="simple-form">
                  <v-form
                    ref="generalForm"
                    lazy-validation>
                    <v-alert
                      v-model="updateAccount.showAlertResponse"
                      :dismissible="true"
                      :type="updateAccount.alertType"
                      class="mb-3"
                    >
                      {{ updateAccount.alertMessage }}
                    </v-alert>
                    <v-layout wrap>
                      <v-flex md4>
                        <v-text-field
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Acct_name"
                          label="Calculated Account Name"
                        />
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          v-model="updateAccount.record.Requestor_FullName"
                          readonly
                          label="Requested By"
                        />
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          v-model="updateAccount.record.Date_Requested"
                          readonly
                          label="Date Requested"
                        />
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          v-model="updateAccount.record.OBS_Date_Updated"
                          label="Date Updated"
                          disabled
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex md6>
                        <v-text-field
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Calculated_Master_Payer"
                          label="Calculated_MP"
                        />
                      </v-flex>
                      <v-flex>
                        <v-select
                          :disabled="!isRecordView"
                          :items="['DXC Gold', 'DXC Silver']"
                          v-model="updateAccount.record.Managed_Svc"
                          attach
                          label="Managed SVC"
                        />
                      </v-flex>
                    </v-layout>
                    <v-select
                      :disabled="!isRecordView"
                      :items="['New', 'Pending OppReg', 'Request Validation in Progress', 'Account Configuration in Progress', 'Account Creation Completed', 'Delivered to Requestor', 'ORR in Progress', 'Handover to CloudOps', 'Request Cancelled']"
                      v-model="updateAccount.record.Onboarding_Status"
                      attach
                      label="Onboarding Status"
                    />
                    <v-menu
                      v-model="dates.date_onboarded"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Date_onboarded"
                          readonly
                          label="Date Onboarded"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        :disabled="!isRecordView"
                        v-model="dateOnboarded"
                        @input="dates.date_onboarded = false"/>
                    </v-menu>

                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Acct_DL"
                      label="Account_DL"
                    />
                    <!-- <v-text-field
                      v-validate="updateAccount.record.Onboarding_Status === 'Delivered to Requestor' ? 'required' : ''"
                      v-model="updateAccount.record.Acct_ID"
                      :error-messages="errors.collect('Acct_ID')"
                      data-vv-name="Acct_ID"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label">
                        <span v-html="updateAccount.record.Onboarding_Status === 'Delivered to Requestor' ? `Account ID <span class='required'>*</span>` : `Account ID`"/>
                      </template>
                    </v-text-field> -->

                    <v-text-field
                      v-if="updateAccount.record.AWS_Req_Type === 'New'"
                      v-model="updateAccount.record.Registration_Id"
                      required
                      readonly
                      label="Registration ID"
                    />
                    <v-text-field
                      v-validate="updateAccount.record.Onboarding_Status === 'Delivered to Requestor' ? 'required' : ''"
                      v-model.trim="updateAccount.record.Acct_ID"
                      :counter="12"
                      :disabled="!isRecordView"
                      :error="updateAccount.accountIdExistError"
                      :error-messages="updateAccount.accountIdExistErrorMessages"
                      :success="updateAccount.accountIdExistSuccess"
                      :success-messages="updateAccount.accountIdExistSuccessMessages"
                      :loading="updateAccount.accountIdExistLoading"
                      @change="checkIfAccountIdIsAvailable"
                    >
                      <template slot="label">
                        <span v-html="updateAccount.record.Onboarding_Status === 'Delivered to Requestor' ? `Account ID <span class='required'>*</span>` : `Account ID`"/>
                      </template>
                    </v-text-field>

                    <v-text-field
                      :disabled="!isRecordView"
                      v-model.trim="updateAccount.record.Acct_Alias_Group"
                    >
                      <template slot="label">
                        <span v-html="`Account Group`"/>
                      </template>
                    </v-text-field>

                    <v-textarea
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Acct_Description"
                      :value="''"
                      clearable
                      label="Account Description" />

                    <v-autocomplete
                      v-validate="'required'"
                      v-model="updateAccount.record.MP_ID"
                      :items="masterPayer"
                      :error-messages="errors.collect('MP_ID')"
                      :disabled="!isRecordView"
                      item-text="MP_Name"
                      item-value="Master_Id"
                      flat
                      hide-no-data
                      hide-details
                      no-data-text="No results found"
                      data-vv-name="MP_ID"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label">
                        <span v-html="`Master Payer <span style='color:red' class='required'>*</span>`"/>
                      </template>
                    </v-autocomplete>

                    <v-text-field
                      v-model="showStatuses.AWS_Support_Type"
                      required
                      readonly
                      label="AWS Support Type (read-only)"
                    />

                    <v-text-field
                      :disabled="!isRecordView"
                      v-if="updateAccount.record.AWS_Req_Type === 'New'"
                      v-model="updateAccount.record.Tmp_Cust_Name"
                      required
                      label="SFDC Customer Name"
                    />

                    <v-autocomplete
                      v-validate="'required'"  
                      v-model="updateAccount.record.Customer_Id"
                      :loading="updateAccount.searchLoading"
                      :items="customers"
                      :error-messages="errors.collect('Customer_Id')"
                      :search-input.sync="search"
                      :disabled="!isRecordView"
                      item-text="Cust_Region"
                      item-value="Customer_Id"
                      cache-items
                      flat
                      hide-no-data
                      hide-details
                      label="Customer Name"
                      attach
                      style="z-index:999"
                      light
                      data-vv-name="Customer_Id"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label">
                        <span v-html="`Customer Name <span style='color:red' class='required'>*</span>`"/>
                      </template>
                    </v-autocomplete>

                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.OppReg_Id"
                      label="Opportunity ID (read-only)"
                      disabled
                    />
                    
                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.GovCloud_Resource_Account"
                      label="GovCloud Resource Account"/>
                    <!-- <v-text-field
                      v-model.trim="updateAccount.record.Opportunity_Number"
                      :error="updateAccount.opportunityNumberExistError"
                      :error-messages="updateAccount.opportunityNumberExistErrorMessages"
                      :success="updateAccount.opportunityNumberExistSuccess"
                      :success-messages="updateAccount.opportunityNumberExistSuccessMessages"
                      :loading="updateAccount.opportunityNumberExistLoading"
                      @change="checkIfOpportunityNumberIsAvailable"
                      :label="showStatuses.Workload_Status && showStatuses.Workload_Status.indexOf('Approved') == -1 && showStatuses.Workload_Status !== 'Submitted by User' ? 'ACE Opportunity Number (read-only)' : 'ACE Opportunity Number'"
                      :disabled="showStatuses.Workload_Status && showStatuses.Workload_Status.indexOf('Approved') == -1 && showStatuses.Workload_Status !== 'Submitted by User'"
                    /> -->

                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="showStatuses.Workload_Status"
                      label="Workload Status (read-only)"
                      disabled
                    />

                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="showStatuses.WS_Selected"
                      label="WS Selected (read-only)"
                      disabled
                    />
                    <!-- <v-text-field
                      v-model="updateAccount.record.Engr_Assigned_To"
                      label="Engineer Assigned"
                    /> -->
                     
                    <template>
                        <v-combobox v-model="updateAccount.Notification_List"
                                    label="List of users who will receive notifications from AWS on account usage"
                                    chips
                                    clearable
                                    :rules="emailRules"
                                    :disabled="!isRecordView"
                                    multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        :disabled="!isRecordView"
                                        close
                                        @input="notificationListRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                    <template>
                        <v-combobox v-model="updateAccount.IAM_Users"
                                    label="List of users for the account who need Admin access"
                                    chips
                                    clearable
                                    :rules="emailRules"
                                    :disabled="!isRecordView"
                                    multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        :disabled="!isRecordView"
                                        close
                                        @input="iAmUsersRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                    <template>
                        <v-combobox v-model="updateAccount.Financial_Owner"
                                    label="Who is the financial owner of the AWS account (owner of WBS / IWO associated with it)?"
                                    chips
                                    clearable
                                    :rules="emailRules"
                                    :disabled="!isRecordView"
                                    multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        :disabled="!isRecordView"
                                        close
                                        @input="financeOwnersRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                   

                    <v-layout
                      row
                      wrap>
                      <v-flex
                        xs12
                        sm12
                        md10
                        xl10>
                        <v-autocomplete
                          v-validate="'required'"
                          v-model="updateAccount.record.Engr_Assigned_To"
                          :items="obEngineers"
                          :error-messages="errors.collect('Id')"
                          :disabled="!isRecordView"
                          item-text="Name_Email"
                          item-value="Id"
                          flat
                          data-vv-name="Id"
                          data-vv-validate-on="blur"
                        >
                          <template slot="label">
                            <span v-html="`Engineer Assigned`"/>
                          </template>

                        </v-autocomplete>
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md2
                        xl2>
                        <v-btn
                          :disabled="!isRecordView"
                          icon
                          x-small
                          color="#e8e6e6"
                          @click="addEngineer">
                          <v-icon small >add</v-icon>
                        </v-btn>
                        <v-btn
                          :disabled="!isRecordView"
                          icon
                          x-small
                          color="#e8e6e6"
                          @click="sendEngrEmail">
                          <v-icon small >mdi-email</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                
                    <!-- <v-select
                      :items="mfaList"
                      v-model="mfa"
                      attach
                      label="MFA"
                    />
                    <v-text-field
                      v-validate="mfa === 'Other' || !mfaList.includes(mfa) ? 'required' : ''"
                      v-if="mfa === 'Other' || !mfaList.includes(mfa)"
                      v-model="otherMFA"
                      :error-messages="errors.collect('Other_MFA')"
                      data-vv-name="Other_MFA"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field>
                    <v-select
                      :items="rcsList"
                      v-model="rootCredentialStore"
                      attach
                      label="Root Credential Store"
                    />
                    <v-text-field
                      v-validate="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore) ? 'required' : ''"
                      v-if="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore)"
                      v-model="otherRootCredentialStore"
                      :error-messages="errors.collect('Other_Root_Credential_Store')"
                      data-vv-name="Other_Root_Credential_Store"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field> -->
                    <v-card
                      v-if="isCreateObEngr"
                      style="margin-bottom:10px">
                      <v-toolbar
                        color="orange"
                        dense
                        flat
                      >
                        <span color="#fff">Add New Engineer</span>
                      </v-toolbar>
                      <div
                        v-if="showEngrDialog.message"
                        style="padding:10px 25px;margin: 15px 25px; border: 1px dotted red;font-color: red; font-weight:400">
                        {{ showEngrDialog.message }}
                      </div>
                      <v-container fluids>

                        <v-layout
                          row
                          wrap>
                          <v-flex
                            xs12
                            sm12
                            md12
                            xl12>
                            <v-text-field
                              :disabled="!isRecordView"
                              v-model="createObEngr.Name"
                              label = "Name"
                              placeholder="Name"
                            />
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            xl12>
                            <v-text-field
                              :disabled="!isRecordView"
                              v-model="createObEngr.Email"
                              label="Email"
                              placeholder="Email"
                            />
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            xl12>
                            <v-btn
                              :disabled="!createObEngr.Name || !createObEngr.Email || !isRecordView"
                              @click="createEngineer">Create</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                      <v-select
                      :disabled="!isRecordView"
                      :items="mfaList"
                      v-model="mfa"
                      attach
                      label="MFA"
                    />
                    <v-text-field
                      v-validate="mfa === 'Other' || !mfaList.includes(mfa) ? 'required' : ''"
                      v-if="mfa === 'Other' || !mfaList.includes(mfa)"
                      v-model="otherMFA"
                      :error-messages="errors.collect('Other_MFA')"
                      :disabled="!isRecordView"
                      data-vv-name="Other_MFA"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field>
                    <v-select
                      :items="rcsList"
                      :disabled="!isRecordView"
                      v-model="rootCredentialStore"
                      attach
                      label="Root Credential Store"
                    />
                    <v-text-field
                      v-validate="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore) ? 'required' : ''"
                      v-if="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore)"
                      v-model="otherRootCredentialStore"
                      :error-messages="errors.collect('Other_Root_Credential_Store')"
                      :disabled="!isRecordView"
                      data-vv-name="Other_Root_Credential_Store"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field> 
                  </v-form>
                  <v-card class="elevation-1">
                    <v-card-text>
                      Changelogs
                      <v-progress-linear
                        v-slot:progress
                        v-if="updateAccount.loadingChangeLog"
                        color="orange"
                        indeterminate/>
                      <v-data-table
                        :headers="updateAccount.changeLogHeaders"
                        :items="updateAccount.changeLogs"
                        :loading="true"
                        :pagination.sync="LogsPagination"
                        class="elevation-1"
                      >
                        <template v-slot:items="props">
                          <td>{{ props.item.Log_Id }}</td>
                          <td>{{ props.item.action }}</td>
                          <td>{{ props.item.User }}</td>
                          <td>
                            <pre v-html="props.item.Change_From" />
                          </td>
                          <td>
                            <pre v-html="props.item.Change_To" />
                          </td>
                          <td>{{ props.item.Create_Date }}</td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </div>
                <div
                  v-else
                  class="full-form">
                  <v-form
                    ref="generalForm"
                    
                    lazy-validation>
                    <v-alert
                      v-model="updateAccount.showAlertResponse"
                      :dismissible="true"
                      :type="updateAccount.alertType"
                      class="mb-3"
                    >
                      {{ updateAccount.alertMessage }}
                    </v-alert>
                    <v-layout wrap>
                      <v-flex md4>
                        <v-text-field
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Acct_name"
                          label="Calculated Account Name"
                        />
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Requestor_FullName"
                          readonly
                          label="Requested By"
                        />
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Date_Requested"
                          readonly
                          label="Date Requested"
                        />
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          v-model="updateAccount.record.OBS_Date_Updated"
                          label="Date Updated"
                          disabled
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex md6>
                        <v-text-field
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Calculated_Master_Payer"
                          label="Calculated_MP"
                        />
                      </v-flex>
                      <v-flex>
                        <v-select
                          :items="['DXC Gold', 'DXC Silver']"
                          :disabled="!isRecordView"
                          v-model="updateAccount.record.Managed_Svc"
                          attach
                          label="Managed SVC"
                        />
                      </v-flex>
                    </v-layout>

                    <v-autocomplete
                      v-validate="'required'"
                      v-model="updateAccount.record.MP_ID"
                      :items="masterPayer"
                      :error-messages="errors.collect('MP_ID')"
                      :disabled="!isRecordView"
                      item-text="MP_Name"
                      item-value="Master_Id"
                      flat
                      hide-no-data
                      hide-details
                      style="z-index:999"
                      no-data-text="No results found"
                      data-vv-name="MP_ID"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label">
                        <span v-html="`Master Payer <span style='color:red' class='required'>*</span>`"/>
                      </template>
                    </v-autocomplete>
                    <v-select
                      :items="['New', 'Request Validation in Progress', 'Account Configuration in Progress', 'Account Creation Completed', 'Delivered to Requestor', 'ORR in Progress', 'Handover to CloudOps', 'Request Cancelled']"
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Onboarding_Status"
                      attach
                      label="Onboarding Status"
                    />
                    <v-menu
                      v-model="dates.date_onboarded"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="updateAccount.record.Date_onboarded"
                          readonly
                          label="Date Onboarded"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        :disabled="!isRecordView"
                        v-model="dateOnboarded"
                        @input="dates.date_onboarded = false"/>
                    </v-menu>
                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Acct_DL"
                      label="Account_DL"
                    />
                    <v-textarea
                      v-model="updateAccount.record.Acct_Description"
                      :value="''"
                      :disabled="!isRecordView"
                      clearable
                      label="Account Description" />
                    <v-text-field
                      v-validate="updateAccount.record.Onboarding_Status === 'Delivered to Requestor' ? 'required' : ''"
                      v-model.trim="updateAccount.record.Acct_ID"
                      :counter="12"
                      :error="updateAccount.accountIdExistError"
                      :error-messages="updateAccount.accountIdExistErrorMessages"
                      :success="updateAccount.accountIdExistSuccess"
                      :success-messages="updateAccount.accountIdExistSuccessMessages"
                      :loading="updateAccount.accountIdExistLoading"
                      :disabled="!isRecordView"
                      @change="checkIfAccountIdIsAvailable"
                    >
                      <template slot="label">
                        <span v-html="updateAccount.record.Onboarding_Status === 'Delivered to Requestor' ? `Account ID <span class='required'>*</span>` : `Account ID`"/>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model.trim="updateAccount.record.Acct_Alias_Group"
                    >
                      <template slot="label">
                        <span v-html="`Acct Alias Group`"/>
                      </template>
                    </v-text-field>

                    <!-- <v-autocomplete
                      v-model="updateAccount.record.MP_ID"
                      :items="masterPayer"
                      item-text="MP_Name"
                      item-value="Master_Id"
                      flat
                      hide-no-data
                      hide-details
                      label="Master Payer"
                      style="z-index:999"
                      no-data-text="No results found"
                    /> -->

                    <v-text-field
                      v-model="updateAccount.record.OppReg_Id"
                      label="Opportunity ID (read-only)"
                      disabled
                    />

                    <!-- <v-text-field
                      v-model.trim="updateAccount.record.Opportunity_Number"
                      :error="updateAccount.opportunityNumberExistError"
                      :error-messages="updateAccount.opportunityNumberExistErrorMessages"
                      :success="updateAccount.opportunityNumberExistSuccess"
                      :success-messages="updateAccount.opportunityNumberExistSuccessMessages"
                      :loading="updateAccount.opportunityNumberExistLoading"
                      @change="checkIfOpportunityNumberIsAvailable"
                      :label="showStatuses.Workload_Status && showStatuses.Workload_Status.indexOf('Approved') == -1 && showStatuses.Workload_Status !== 'Submitted by User' ? 'ACE Opportunity Number (read-only)' : 'ACE Opportunity Number'"
                      :disabled="showStatuses.Workload_Status && showStatuses.Workload_Status.indexOf('Approved') == -1 && showStatuses.Workload_Status !== 'Submitted by User'"
                    /> -->
                    <!-- <v-text-field
                      v-model="updateAccount.record.Engr_Assigned_To"
                      label="Engineer Assigned"
                    /> -->

                     <template>
                        <v-combobox v-model="updateAccount.Notification_List"
                                    label="List of users who will receive notifications from AWS on account usage"
                                    chips
                                    clearable
                                    :rules="emailRules"
                                    :disabled="!isRecordView"
                                    multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        close
                                        @input="notificationListRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                    <template>
                        <v-combobox v-model="updateAccount.IAM_Users"
                                    label="List of users for the account who need Admin access"
                                    chips
                                    clearable
                                    :rules="emailRules"
                                    :disabled="!isRecordView"
                                    multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        close
                                        @input="iAmUsersRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                    <template>
                        <v-combobox v-model="updateAccount.Financial_Owner"
                                    label="Who is the financial owner of the AWS account (owner of WBS / IWO associated with it)?"
                                    chips
                                    clearable
                                    :rules="emailRules"
                                    :disabled="!isRecordView"
                                    multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        close
                                        @input="financeOwnersRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                   

                    <v-layout
                      row
                      wrap>
                      <v-flex
                        xs12
                        sm12
                        md10
                        xl10>
                        <v-autocomplete
                          v-validate="'required'"
                          v-model="updateAccount.record.Engr_Assigned_To"
                          :items="obEngineers"
                          :error-messages="errors.collect('Id')"
                          :disabled="!isRecordView"
                          item-text="Name_Email"
                          item-value="Id"
                          flat
                          data-vv-name="Id"
                          data-vv-validate-on="blur"
                        >
                          <template slot="label">
                            <span v-html="`Engineer Assigned`"/>
                          </template>

                        </v-autocomplete>
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md2
                        xl2>
                        <v-btn
                          :disabled="!isRecordView"
                          icon
                          x-small
                          color="#e8e6e6"
                          @click="addEngineer">
                          <v-icon small >add</v-icon>
                        </v-btn>
                        <v-btn
                          :disabled="!isRecordView"
                          icon
                          x-small
                          color="#e8e6e6"
                          @click="sendEngrEmail" >
                          <v-icon small >mdi-email</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-card v-if="isCreateObEngr">
                      <v-toolbar
                        color="orange"
                        dense
                        flat
                      >
                        <span color="#fff">Add New Engineer</span>
                      </v-toolbar>
                      <div
                        v-if="showEngrDialog.message"
                        style="padding:10px 25px;margin: 15px 25px; border: 1px dotted red;font-color: red; font-weight:400">
                        {{ showEngrDialog.message }}
                      </div>
                      <v-container fluids>

                        <v-layout
                          row
                          wrap>
                          <v-flex
                            xs12
                            sm12
                            md12
                            xl12>
                            <v-text-field
                              :disabled="!isRecordView"
                              v-model="createObEngr.Name"
                              label = "Name"
                              placeholder="Name"
                            />
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            xl12>
                            <v-text-field
                              :disabled="!isRecordView"
                              v-model="createObEngr.Email"
                              label="Email"
                              placeholder="Email"
                            />
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            xl12>
                            <v-btn
                              :disabled="!createObEngr.Name || !createObEngr.Email || !isRecordView"
                              @click="createEngineer">Create</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>

                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Request_Type"
                      required
                      label="Request Type" />

                    <!-- <v-text-field
                      v-if="updateAccount.record.AWS_Req_Type === 'New'"
                      v-model="updateAccount.record.Tmp_Cust_Name"
                      required
                      label="SFDC Customer Name"
                    /> -->
                    <!-- <v-text-field
                      v-model="updateAccount.record.Customer_Name"
                      required
                      label="Customer Name" /> -->

                    <!-- <v-autocomplete
                      v-model="updateAccount.record.Customer_Id"
                      :loading="updateAccount.searchLoading"
                      :items="customers"
                      :search-input.sync="search"
                      item-text="Customer_Name"
                      item-value="Customer_Id"
                      cache-items
                      flat
                      hide-no-data
                      hide-details
                      label="Customer Name"
                      attach
                      style="z-index:999"
                      light
                      no-data-text="No results found"
                    /> -->
                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.WBS_code"
                      required
                      label="WBS" />
                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.IWO_Code"
                      required
                      label="IWO" />
                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.AWS_credits"
                      required
                      label="AWS Credits" />
                    <v-switch
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Acct_Restricted"
                      label="Account Restricted?"
                      value="Yes"/>
                    <v-select
                      :disabled="!isRecordView"
                      :items="['all', 'amer', 'emea', 'eu', 'apac', 'anz']"
                      v-model="updateAccount.record.Specific_Region"
                      attach
                      label="Region"
                    />
                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Specific_Location"
                      required
                      label="Location" />
                    <v-switch
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.SaaS"
                      label="SaaS?"
                      value="Yes"/>
                    <v-switch
                      :disabled="!isRecordView"
                      v-model="updateAccount.record.Business_Use"
                      label="Business Use?"
                      value="Yes"/>
                
                    <v-select
                      :disabled="!isRecordView"
                      :items="mfaList"
                      v-model="mfa"
                      attach
                      label="MFA"
                    />
                    <v-text-field
                      v-validate="mfa === 'Other' || !mfaList.includes(mfa) ? 'required' : ''"
                      v-if="mfa === 'Other' || !mfaList.includes(mfa)"
                      v-model="otherMFA"
                      :error-messages="errors.collect('Other_MFA')"
                      :disabled="!isRecordView"
                      data-vv-name="Other_MFA"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field>
                    <v-select
                      :items="rcsList"
                      :disabled="!isRecordView"
                      v-model="rootCredentialStore"
                      attach
                      label="Root Credential Store"
                    />
                    <v-text-field
                      v-validate="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore) ? 'required' : ''"
                      v-if="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore)"
                      v-model="otherRootCredentialStore"
                      :error-messages="errors.collect('Other_Root_Credential_Store')"
                      :disabled="!isRecordView"
                      data-vv-name="Other_Root_Credential_Store"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field>
                  </v-form>
                </div>
              </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer/>
              <v-btn @click.stop="updateAccount.showDialog = false">Close</v-btn>
              <v-btn 
              v-if="this.S3ObjectKey !== 'None'"
              :disabled="!isRecordView"
              @click="downloadDocument"
              color="orange"
              >Download</v-btn>
              <v-btn
                :disabled="formIsValid || !isRecordView"
                :loading="updateAccount.saving"
                color="orange"
                @click="onUpdateWorkflow"
              >Update</v-btn>
              <v-btn
                :disabled="!checkIfValidForAccountCreation || !isRecordView"
                class="ml-2"
                color="green"
                :loading="createAccount.creating"
                @click="createAWSAccount"
              >Create AWS Account</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- IF ACCOUNT ID ALREADY EXIST -->
        <v-dialog v-model="updateAccount.isAccountIdExist" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                Would you like to override data from existing onboarding account?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="!isRecordView"
                  color="orange darken-1"
                  text
                  @click="updateExistingAcctId"
                >
                  Yes
                </v-btn>
                <v-btn
                  :disabled="!isRecordView"
                  color="orange darken-1"
                  text
                  @click="closeAcctIdDialog"
                >
                  No
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        <!-- <v-dialog v-model="createAccount.showDialog" persistent max-width="500">
          <v-card>
            <v-card-text>
              <v-container>
                <v-layout>
                  <v-flex>
                    <p>To proceed on creating the AWS Account, please provide the following information:</p>
                    <v-text-field
                        v-model="createAccount.fields.external_id"
                        label="CloudCheckr External Account Id"
                        solo
                        v-validate="'min:20'"
                        :error-messages="errors.collect('external_id')"
                        :disabled="!isRecordView"
                        data-vv-validate-on="blur"
                        data-vv-as="external_id" 
                        name="external_id"
                      />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer/>
              <v-btn @click="closeCreateAccount">Close</v-btn>
              <v-btn
                :disabled="validateExternalId"
                color="orange"
                @click="createAWSAccount"
              >Continue</v-btn>
            </v-card-actions>  
          </v-card>
        </v-dialog> -->

      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { checkActionPermission } from '@/utils/helper'

export default {
  data () {
    return {
      valid:null,
      fullDetailForm: false,
      accountId: null,
      search: '',
      S3ObjectKey: '',
      Requestor_Email: '',
      LogsPagination: {
        descending: true,
        sortBy: 'Log_Id'
      },
      dates: {
        date_onboarded: false
      },
      mfaList: ['Vault0', 'Vault0eu', 'Vault0us', 'KeePass AU (KeeOTP)', 'KeePass US (KeeOTP) - Legacy', 'KeePass EU (KeeOTP) - Legacy', 'Authy (MP)', 'Authy (Child) - Legacy', 'Hardware key (acct owner)', 'None', 'Other'],
      rcsList: ['Vault0', 'Vault0eu', 'Vault0us', 'KeePass Global (Legacy)', 'KeePass AU', 'KeePass US - Legacy', 'KeePass EU - Legacy', 'KeePass (MP)', 'None', 'Other'],
      emailRules :[
      v => {
        if (!v || v.length < 1)
          return 'Input is required';
        else if (v.length > 0) {
          for (let i = 0; i < v.length; i++) {
                if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Input must be valid email format';
              }
            }
          }
        else return true;
      }
      ],
      externalIdRules: [
        v => {
          if (!v || v.length < 20) return "External Id should be at least 20 characters"
        }
      ]
    }
  },
  computed: {
    ...mapState('admin/accountOnboarding', ['onboardingAccounts', 'createAccount', 'updateAccount', 'existingOnboardingAccount', 'showStatuses', 'masterPayer', 'obEngineers', 'createObEngr', 'isCreateObEngr', 'showEngrDialog']),
    ...mapState('admin', ['customers']),
    formIsValid () {
      return this.updateAccount.accountIdExistLoading
      || this.updateAccount.opportunityNumberExistLoading 
      || this.errors.items.length 
      || this.updateAccount.accountIdExistError
      || this.updateAccount.opportunityNumberExistError
      || !this.updateAccount.record.Customer_Id 
      || this.updateAccount.record.Customer_Id === 'None'
    },
    mfa: {
      get: function () {
        return this.mfaList.includes(this.updateAccount.record.MFA) ? this.updateAccount.record.MFA : 'Other'
      },
      set: function (val) {
        this.updateAccount.record.MFA = val
      }
    },
    otherMFA: {
      get: function () {
        return !this.mfaList.includes(this.updateAccount.record.MFA) ? this.updateAccount.record.MFA : ''
      },
      set: function (mfa) {
        this.updateAccount.record.MFA = mfa
      }
    },
    rootCredentialStore: {
      get: function () {
        return this.rcsList.includes(this.updateAccount.record.Root_Credential_Store) ? this.updateAccount.record.Root_Credential_Store : 'Other'
      },
      set: function (val) {
        this.updateAccount.record.Root_Credential_Store = val
      }
    },
    otherRootCredentialStore: {
      get: function () {
        return !this.rcsList.includes(this.updateAccount.record.Root_Credential_Store) ? this.updateAccount.record.Root_Credential_Store : ''
      },
      set: function (rcs) {
        this.updateAccount.record.Root_Credential_Store = rcs
      }
    },
    dateOnboarded: {
      get: function () {
        return this.updateAccount.record.Date_onboarded !== '0000-00-00' && this.updateAccount.record.Date_onboarded !== 'None' ? this.updateAccount.record.Date_onboarded : ''
      },
      set: function (dateOnboarded) {
        this.updateAccount.record.Date_onboarded = dateOnboarded
      }
    },
    validateExternalId() {

      if (!this.createAccount.fields.external_id) return true

      let errorIndex = this.errors.items.findIndex( e => e.field=='external_id')
      return errorIndex != -1 ? true : false
    },
    checkIfValidForAccountCreation () {
      let currentAccount = this.onboardingAccounts.find( account => account.Onboarding_Id === this.updateAccount.record.Onboarding_Id)

      if (currentAccount) {
        if ( 
          currentAccount.MP_ID && currentAccount.MP_ID !== 'None' && 
          (!currentAccount.Acct_ID || currentAccount.Acct_ID === 'None') && 
          !['Delivered to Requestor', 'Account Configuration in Progress'].includes(currentAccount.Onboarding_Status) && 
          currentAccount.Acct_DL && 
          currentAccount.Managed_Svc && 
          currentAccount.Managed_Svc !== 'None' 
          ) {
          return true
        } else {
          return false
        }
      }
    },
    isRecordView() {
      return checkActionPermission('write', 'onboard-aws-account')
    },
  },
  mounted () {
    this.$store.dispatch('admin/accountOnboarding/getAllMasterPayer')
    this.$store.dispatch('admin/accountOnboarding/getAllObEngineers')
  },
  beforeDestroy () {
    this.$store.commit('admin/accountOnboarding/clearViewRequestData')
  },
  methods: {
    openUpdateDialog (record) {
      this.$store.commit('admin/accountOnboarding/clearUpdateDialog')
      this.$store.commit('admin/accountOnboarding/updateContactEmails', record)
      this.$store.commit('admin/accountOnboarding/showUpdateDialog', record)
      this.S3ObjectKey = record.S3_Filename
      this.Requestor_Email = record.Requestor_Email

      let notify = JSON.parse(record.Notification_List)
      let notifyy = JSON.stringify(notify.map(record => record)) 
      let iamuser = JSON.parse(record.IAM_Users)
      let iamuserr = JSON.stringify(iamuser.map(record => record)) 
      let finance = JSON.parse(record.Financial_Owner)
      let financee = JSON.stringify(finance.map(record => record)) 
      
      // record.Notification_List = notifyy.replace(/[ "/+?^${}()|[\]\\]/g,'')
      // record.IAM_Users = iamuserr.replace(/[ "/+?^${}()|[\]\\]/g,'')
      // record.Financial_Owner = financee.replace(/[ "/+?^${}()|[\]\\]/g,'') 
      let onboardingRecord = {
              AWS_Req_Type: record.AWS_Req_Type,
              AWS_credits: record.AWS_credits,
              Account_Owners: record.Account_Owners,
              AcctSecurity_Id: record.AcctSecurity_Id,
              Acct_Alias_Group: record.Acct_Alias_Group,
              Acct_DL: record.Acct_DL,
              Acct_Description: record.Acct_Description,
              Acct_Exp_Id: record.Acct_Exp_Id,
              Acct_ID: record.Acct_ID,
              Acct_Restricted: record.Acct_Restricted,
              Acct_name: record.Acct_name,
              Business_Use: record.Business_Use,
              Calculated_Master_Payer: record.Calculated_Master_Payer,
              // CloudCheckr_users: record.CloudCheckr_users,
              Customer_Id: record.Customer_Id,      
              Customer_Name: record.Customer_Name,
              Date_Requested: record.Date_Requested,
              Date_onboarded: record.Date_onboarded,
              Engr_Assigned_To: record.Engr_Assigned_To,
              Financial_Id: record.Financial_Id,
              Financial_Owner: financee.replace(/[ "/+?^${}()|[\]\\]/g,''),
              IAM_Users:  iamuserr.replace(/[ "/+?^${}()|[\]\\]/g,''),
              IWO_Code: record.IWO_Code,
              MFA: record.MFA,
              MP_ID: record.MP_ID,
              Managed_Svc: record.Managed_Svc,
              Notification_List: notifyy.replace(/[ "/+?^${}()|[\]\\]/g,''),
              OBS_Date_Updated: record.OBS_Date_Updated,
              Onboarding_Id: record.Onboarding_Id,
              Onboarding_Status: record.Onboarding_Status,
              OppReg_Id: record.OppReg_Id,
              // Opportunity_Number: record.Opportunity_Number,
              Registration_Id: record.Registration_Id,
              Request_Type: record.Request_Type,
              Requestor_FullName: record.Requestor_FullName,
              Root_Credential_Store: record.Root_Credential_Store,
              SaaS: record.SaaS,
              Specific_Location: record.Specific_Location,
              Specific_Region: record.Specific_Region,
              Tmp_Cust_Name: record.Tmp_Cust_Name,
              Unique_Agreement_Id: record.Unique_Agreement_Id,
              WBS_code: record.WBS_code,
              Is_Training_Account: record.Is_Training_Account
            }
      this.$store.commit('setChangeLogRecord', { id: record.Onboarding_Id, changeFrom:  onboardingRecord }, { root: true })
      this.$store.dispatch('admin/accountOnboarding/getOnboardingLogs', record.Onboarding_Id)
    },

    notificationListRemove(item) {
      this.updateAccount.Notification_List.splice(this.updateAccount.Notification_List.indexOf(item), 1)
      this.updateAccount.Notification_List = [...this.updateAccount.Notification_List]
    },
    iAmUsersRemove(item) {
      this.updateAccount.IAM_Users.splice(this.updateAccount.IAM_Users.indexOf(item), 1)
      this.updateAccount.IAM_Users = [...this.updateAccount.IAM_Users]
    },
    financeOwnersRemove(item) {
      this.updateAccount.Financial_Owner.splice(this.updateAccount.Financial_Owner.indexOf(item), 1)
      this.updateAccount.Financial_Owner = [...this.updateAccount.Financial_Owner]
    },
    onUpdateWorkflow () {
      this.$store.commit('admin/accountOnboarding/updateOnboardingContacts')
      this.$store.dispatch('admin/accountOnboarding/updateWorkflow', this.updateAccount.record)
    },
    searchCustomer (searchItem) {
      this.$store.dispatch('admin/accountOnboarding/searchCustomers', searchItem)
    },
    checkIfAccountIdIsAvailable () {
      this.$store.dispatch('admin/accountOnboarding/checkIfAccountIdIsAvailable', this.updateAccount.record.Acct_ID, { root: true })
    },
    // checkIfOpportunityNumberIsAvailable () {
    //   this.$store.dispatch('admin/accountOnboarding/checkIfOpportunityNumberIsAvailable', this.updateAccount.record.Opportunity_Number, { root: true })
    // },
    addEngineer () {
      this.$store.commit('admin/accountOnboarding/setShowAddEngr', true)
    },
    createEngineer () {
      this.$store.dispatch('admin/accountOnboarding/createEngineer', this.createObEngr)
    },
    sendEngrEmail () {
      let engrAssignedTo = this.updateAccount.record.Engr_Assigned_To
      if (engrAssignedTo === 'None') {
        this.$store.commit('showDialog',
          {
            show: true,
            type: 'alert',
            persistent: true,
            title: 'Engineer Assigned is empty!'
          },
          { root: true }
        )
      } else {
        let sendToEmail = this.obEngineers.filter(res => {
          if (res.Id === engrAssignedTo) {
            return res.Email
          }
        }
        )
        // let masterPayerAccountNumber = this.masterPayer.find(mp => {
        //     return mp.Master_Id === this.updateAccount.record.MP_ID
        //   })
        let masterPayerAccountNumber = this.masterPayer.filter(res => {
          return res.Master_Id === this.updateAccount.record.MP_ID
        })
        let sendEmailData = {
          sent_to: sendToEmail[0].Email,
          OppReg_Id: this.updateAccount.record.OppReg_Id,
          Managed_Svc: this.updateAccount.record.Managed_Svc,
          Acct_name: this.updateAccount.record.Acct_name,
          Acct_Description: this.updateAccount.record.Acct_Description,
          MP_ID: masterPayerAccountNumber[0].MP_ID,
          Account_Owners: this.updateAccount.record.Account_Owners,
          WBS_code: this.updateAccount.record.WBS_code,
          IAM_Users: this.updateAccount.record.IAM_Users,
          Notification_List: this.updateAccount.record.Notification_List,
          Financial_Owner: this.updateAccount.record.Financial_Owner,
          CLoudCheckr_users: this.updateAccount.record.CloudCheckr_users,
          Acct_DL: this.updateAccount.record.Acct_DL,
        }
        this.$store.dispatch('admin/accountOnboarding/sendEngrEmail', sendEmailData)
      }
    },
    updateExistingAcctId() {
      // let r = Math.random().toString(36).substring(7);
      let randomNum= Math.floor(100000 + Math.random() * 900000)

      let assignAcctId = 'ORDUMP'+randomNum
      // this.$store.commit('admin/accountOnboarding/setNewAcctId', assignAcctId)
      this.$store.commit('admin/accountOnboarding/setOnboardingStatus', 'Request Cancelled')
      this.$store.dispatch('admin/accountOnboarding/updateExistingAcctId', { accountId: assignAcctId, onboardingId:this.existingOnboardingAccount.Onboarding_Id, data: this.existingOnboardingAccount, showData: this.updateAccount })

    },
    closeAcctIdDialog(){
      let notify = JSON.parse(this.updateAccount.record.Notification_List)
      let notifyy = JSON.stringify(notify.map(record => record)) 
      let iamuser = JSON.parse(this.updateAccount.record.IAM_Users)
      let iamuserr = JSON.stringify(iamuser.map(record => record)) 
      let finance = JSON.parse(this.updateAccount.record.Financial_Owner)
      let financee = JSON.stringify(finance.map(record => record)) 
      let openRecord =  {
          Onboarding_Id: this.updateAccount.record.Onboarding_Id,
          Acct_name: this.updateAccount.record.Acct_name,
          Acct_Description: this.updateAccount.record.Acct_Description,
          Requestor_FullName: this.updateAccount.record.Requestor_FullName,
          Date_Requested: this.updateAccount.record.Date_Requested,
          Managed_Svc: this.updateAccount.record.Managed_Svc,
          Calculated_Master_Payer: this.updateAccount.record.Calculated_Master_Payer,
          Acct_DL:this.updateAccount.record.Acct_DL,
          Acct_ID: this.updateAccount.record.acctId,
          Acct_Alias_Group: this.updateAccount.record.Acct_Alias_Group,
          Onboarding_Status: this.updateAccount.record.Onboarding_Status,
          Date_onboarded: this.updateAccount.record.Date_onboarded,
          Acct_Restricted: this.updateAccount.record.Acct_Restricted,
          Business_Use: this.updateAccount.record.Business_Use,
          Customer_Id: this.updateAccount.record.Customer_Id,
          Customer_Name: this.updateAccount.record.Customer_Name,
          Financial_Id: this.updateAccount.record.Financial_Id,
          Aws_credits: this.updateAccount.record.Aws_credits,
          WBS_code: this.updateAccount.record.WBS_code,
          IWO_code: this.updateAccount.record.IWO_code,
          Request_Type: this.updateAccount.record.Request_Type,
          Saas: this.updateAccount.record.SaaS,
          MFA: this.updateAccount.record.MFA,
          Root_Credential_Store: this.updateAccount.record.Root_Credential_Store,
          Specific_Location: this.updateAccount.record.Specific_Location,
          Specific_Region:this.updateAccount.record.Specific_Region,
          Tmp_Cust_Name: this.updateAccount.record.Tmp_Cust_Name,
          AWS_Req_Type: this.updateAccount.record.AWS_Req_Type,
          AWS_Support_Type: this.updateAccount.record.AWS_Support_Type,
          Master_Id: this.updateAccount.record.Master_Id,
          MP_ID: this.updateAccount.record.MP_ID,
          AcctSecurity_Id: this.updateAccount.record.AcctSecurity_Id, 
          Unique_Agreement_Id: this.updateAccount.record.Unique_Agreement_Id, 
          Acct_Exp_ID: this.updateAccount.record.Acct_Exp_ID,
          Registration_Id: this.updateAccount.record.Registration_Id, 
          Account_Owners: this.updateAccount.record.Account_Owners,
          // CloudCheckr_users: this.updateAccount.CloudCheckr_users,
          IAM_Users: iamuserr.replace(/[ "/+?^${}()|[\]\\]/g,''),
          Notification_List: notifyy.replace(/[ "/+?^${}()|[\]\\]/g,''),
          Financial_Owner: financee.replace(/[ "/+?^${}()|[\]\\]/g,''),
          Invoice_DL: this.updateAccount.record.Invoice_DL
        }
        this.$store.commit('setChangeLogRecord',{ id:this.updateAccount.record.Onboarding_Id, changeFrom:openRecord}, { root: true })
        this.updateAccount.isAccountIdExist= false
    },
    createAWSAccount(){
      
      if (this.updateAccount.record.MP_ID) {
        let mpRecord = vm.$store.state['admin/accountInventory'].masterPayers.find( mp => mp.Master_Id === this.updateAccount.record.MP_ID)
       
        let awsAccountDetails = {
          Onboarding_Id: this.updateAccount.record.Onboarding_Id,
          Masterpayer_ID: mpRecord.MP_ID,
          Acct_name: this.updateAccount.record.Acct_name,
          Acct_DL: this.updateAccount.record.Acct_DL,
          IAM_Users: this.updateAccount.record.IAM_Users,
          Managed_Svc: this.updateAccount.record.Managed_Svc,
          Requestor_Email: this.Requestor_Email,
          external_id: this.createAccount.fields.external_id,
          AWS_Support_Type: this.showStatuses.AWS_Support_Type
        }
        this.$store.dispatch('admin/accountOnboarding/createAccount', awsAccountDetails)
        this.createAccount.showDialog = false
      }
    },
    closeCreateAccount() {
      this.$store.commit('admin/accountOnboarding/resetCreateAccount')
      let errorIndex = this.errors.items.findIndex( e => e.field=='external_id')
      if ( errorIndex != -1 ) {
        this.errors.items.splice(errorIndex, 1)
      }
      this.createAccount.showDialog = false
    },

    downloadDocument() {
      this.$store.dispatch('admin/accountOnboarding/downloadDocument', this.S3ObjectKey)
    }
  }
}
</script>
<style lang="scss" scoped>
.full-detail-link {
  position: absolute;
  right: 20px;
}
.main-btn {
    width: 25px;
    height: 25px;
    border-radius: 50%;
  }
</style>
